import api from './api';

export interface SignalNotificationItem {
  id: string;
  userId: string;
  signalId: string;
  viewedAt: string | null;
  dismissedAt: string | null;
  notifiedVia: string[];
  createdAt: string;
  signal: {
    id: string;
    asset: string;
    direction: 'LONG' | 'SHORT';
    confidence: number;
    narrative: string | null;
    createdAt: string;
    status: string;
  };
}

export const signalNotificationsService = {
  /** Returns the count of unread notifications for the current user. */
  async getUnreadCount(): Promise<number> {
    const response = await api.get<{ count: number }>(
      '/signals/notifications/unread-count'
    );
    return response.data.count;
  },

  /** Returns recent notifications (with joined Signal data). */
  async getRecent(limit = 10): Promise<SignalNotificationItem[]> {
    // NOTE: /signals/notifications/recent returns { data: [...] } WITHOUT a
    // `success` field — it is a non-standard envelope that predates the
    // ApiResponse convention. The response interceptor in api.ts only unwraps
    // when BOTH `success` and `data` keys are present, so this endpoint passes
    // through unchanged and response.data is { data: [...] }.
    // Do NOT "fix" this to response.data — it would break the mapping.
    // To align with the standard envelope, the backend route must be updated first.
    const response = await api.get<{ data: SignalNotificationItem[] }>(
      '/signals/notifications/recent',
      { params: { limit } }
    );
    return response.data.data;
  },

  /** Marks a single notification as viewed. */
  async markViewed(id: string): Promise<void> {
    await api.post(`/signals/notifications/${id}/view`);
  },

  /** Marks all unread notifications as viewed. */
  async markAllRead(): Promise<void> {
    await api.post('/signals/notifications/mark-all-read');
  },
};
